/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Risk levels for roles */
export enum RiskLevel {
  Low,
  Medium,
  High,
  Critical,
}

export type RiskLevelArgs = RiskLevel;

export function getRiskLevelEncoder(): FixedSizeEncoder<RiskLevelArgs> {
  return getEnumEncoder(RiskLevel);
}

export function getRiskLevelDecoder(): FixedSizeDecoder<RiskLevel> {
  return getEnumDecoder(RiskLevel);
}

export function getRiskLevelCodec(): FixedSizeCodec<RiskLevelArgs, RiskLevel> {
  return combineCodec(getRiskLevelEncoder(), getRiskLevelDecoder());
}
